<template>
  <div class="qg-details page-container bg-gradient-soft">
    <div class="container-padded py-5">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="d-flex align-items-center gap-3">
          <router-link to="/question-groups" class="btn btn-outline-secondary btn-with-icon">
            <span class="icon me-1"><i class="fas fa-arrow-left"></i></span> Zurück
          </router-link>
          <h1 class="mb-0 display-heading with-highlight">Fragengruppe</h1>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-outline-danger btn-with-icon" @click="onDeleteGroup" :disabled="(group && group.questions_count > 0)">
            <span class="icon me-1"><i class="fas fa-trash"></i></span> Gruppe löschen
          </button>
          <button class="btn btn-primary btn-with-icon" @click="onSaveGroup" :disabled="savingGroup">
            <span class="icon me-1"><i class="fas fa-save"></i></span> Gruppe speichern
          </button>
        </div>
      </div>

      <!-- Gruppen-Metadaten -->
      <Card animateIn="fadeInUp" class="card-modern card-with-form shadow-lg mb-4">
        <template #header>
          <h4 class="card-title mb-0"><i class="fas fa-layer-group me-2"></i> Gruppeninformationen</h4>
        </template>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">Name</label>
            <input class="form-control apple-style" v-model="groupForm.name" placeholder="z. B. IT-Security" />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">Farbe</label>
            <input class="form-control form-control-color apple-style" type="color" v-model="groupForm.color" />
          </div>
          <div class="col-12">
            <label class="form-label fw-bold">Beschreibung</label>
            <textarea class="form-control apple-style" rows="2" v-model="groupForm.description" placeholder="Beschreibung (optional)"></textarea>
          </div>
          <div class="col-12 d-flex align-items-center gap-2">
            <input id="isActive" type="checkbox" class="form-check-input" v-model="groupForm.is_active" />
            <label for="isActive" class="form-check-label">Gruppe aktiv</label>
          </div>
        </div>
      </Card>

      <!-- Fragenverwaltung -->
      <Card animateIn="fadeInUp" class="card-modern card-with-table shadow-lg">
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0"><i class="fas fa-question-circle me-2"></i> Fragen ({{ questions.length }})</h4>
            <div class="btn-group">
              <button class="btn btn-primary btn-with-icon" @click="startCreate('multiple_choice')">
                <span class="icon me-1"><i class="fas fa-list-ul"></i></span> Multiple-Choice
              </button>
              <button class="btn btn-info btn-with-icon" @click="startCreate('open')">
                <span class="icon me-1"><i class="fas fa-font"></i></span> Offene Frage
              </button>
            </div>
          </div>
        </template>

        <!-- Editorbereich -->
        <div v-if="editing" class="editor card p-3 mb-3">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label fw-bold">Fragetyp</label>
              <select class="form-select form-control apple-style" v-model="form.type">
                <option value="multiple_choice">Multiple-Choice</option>
                <option value="open">Offen</option>
              </select>
            </div>
            <div class="col-md-4" v-if="form.type==='multiple_choice'">
              <label class="form-label fw-bold">Punkte</label>
              <input type="number" class="form-control apple-style" v-model.number="form.points" min="1" />
            </div>
            <div class="col-md-4" v-if="form.type==='open'">
              <label class="form-label fw-bold">Punkte (max)</label>
              <input type="number" class="form-control apple-style" v-model.number="form.max_points" min="1" />
            </div>
            <div class="col-12">
              <label class="form-label fw-bold">Beschreibung</label>
              <textarea class="form-control apple-style" rows="3" v-model="form.description" placeholder="Fragetext"></textarea>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-bold">Reihung (optional)</label>
              <input type="number" class="form-control apple-style" v-model.number="form.sort_order" min="1" />
            </div>
            <div class="col-md-8">
              <label class="form-label fw-bold">Bild (optional)</label>
              <div class="d-flex align-items-center gap-2">
                <input type="file" class="form-control apple-style" accept="image/*" @change="onImageSelect" />
                <button class="btn btn-outline-danger" v-if="form.image_url" @click="removeImage" type="button">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <div v-if="form.image_url" class="mt-2">
                <img :src="form.image_url" class="img-fluid rounded" style="max-height: 160px" />
              </div>
            </div>
          </div>

          <!-- Antwortenbereich -->
          <div v-if="form.type==='multiple_choice'" class="mt-3">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="mb-2">Antwortmöglichkeiten</h6>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="allowMultiple" v-model="form.allow_multiple_answers" />
                <label class="form-check-label" for="allowMultiple">Mehrfachauswahl erlauben</label>
              </div>
            </div>
                          <div class="row g-2">
                <div class="col-md-6" v-for="i in 6" :key="'ans_'+i">
                  <div class="input-group" :class="{ 'is-correct': (!form.allow_multiple_answers && singleCorrect === i) || (form.allow_multiple_answers && form[`is_answer_${i}_correct`]) }">
                    <span class="input-group-text d-inline-flex align-items-center gap-2">
                      <template v-if="!form.allow_multiple_answers">
                        <input type="radio" name="singleCorrect" :value="i" v-model="singleCorrect" @change="setSingleCorrect(i)" />
                        <i :class="singleCorrect === i ? 'fas fa-check-circle text-success' : 'far fa-circle text-muted'"></i>
                      </template>
                      <template v-else>
                        <input type="checkbox" v-model="form[`is_answer_${i}_correct`]" />
                        <i :class="form[`is_answer_${i}_correct`] ? 'fas fa-check-circle text-success' : 'far fa-circle text-muted'"></i>
                      </template>
                    </span>
                    <input type="text" class="form-control apple-style" :placeholder="`Antwort ${i}`" v-model="form[`answer_${i}`]" />
                  </div>
                </div>
              </div>
            <small class="text-muted d-block mt-1">Mindestens eine Antwort muss korrekt sein, und mindestens 2 Antworten sollten gefüllt sein.</small>
          </div>

          <div class="d-flex justify-content-end gap-2 mt-3">
            <button class="btn btn-outline-secondary" type="button" @click="cancelEdit">Abbrechen</button>
            <button class="btn btn-primary" type="button" :disabled="questionSaving" @click="saveQuestion">Speichern</button>
          </div>
        </div>

        <!-- Fragenliste -->
        <div v-if="!questionsLoading && questions.length === 0" class="text-center text-muted py-4">Keine Fragen vorhanden.</div>
        <div v-else>
          <div class="questions-list-modern">
            <div 
              v-for="(element, index) in sortedQuestions" 
              :key="element.id" 
              class="question-card"
              :class="{ 
                'question-card-primary': element.type === 'multiple_choice', 
                'question-card-info': element.type === 'open' 
              }"
            >
              <div class="question-header d-flex align-items-center">
                <div class="question-number-badge me-3">{{ index + 1 }}</div>
                <span class="question-type-badge" 
                  :class="element.type === 'multiple_choice' ? 'badge bg-primary' : 'badge bg-info'">
                  {{ element.type === 'multiple_choice' 
                      ? (element.allow_multiple_answers ? 'Multiple-Choice (Mehrfachauswahl)' : 'Multiple-Choice (Einfachauswahl)') 
                      : 'Offene Frage' }}
                </span>
                <div class="ms-auto question-actions">
                  <button 
                    class="btn-action btn-action-edit" 
                    @click="startEdit(element)"
                    title="Bearbeiten"
                  >
                    <i class="fas fa-edit"></i>
                  </button>
                  <button 
                    class="btn-action btn-action-delete" 
                    @click="onDeleteQuestion(element)"
                    title="Löschen"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
              <div class="question-content mt-3">
                <div class="question-text" v-html="element.description"></div>
                <div v-if="element.type === 'multiple_choice'" class="question-answers mt-3">
                  <div class="answers-title d-flex align-items-center mb-3">
                    <span class="icon icon-primary me-2"><i class="fas fa-list-check"></i></span>
                    <h5 class="mb-0">Antworten</h5>
                    <span class="badge badge-soft-secondary ms-2">mindestens 2 erforderlich</span>
                  </div>
                  <div class="answers-container">
                    <div 
                      v-for="(answer, answerIndex) in element.answers" 
                      :key="`answer-${index}-${answerIndex}`" 
                      class="answer-item"
                      :class="{ 'answer-item-correct': answer.is_correct }"
                    >
                      <div v-if="answerIndex >= 2" class="optional-badge">Optional</div>
                      <div class="answer-content">
                        <div class="answer-checkbox">
                          <span class="answer-status-icon">
                            <i :class="answer.is_correct ? 'fas fa-check-circle' : 'far fa-circle'"></i>
                          </span>
                        </div>
                        <div class="answer-text">{{ answer.text }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Card from '@/components/ui/Card.vue';
import { useQuestionGroupsStore } from '@/stores/questionGroups';
import http from '@/services/http';

export default {
  name: 'QuestionGroupDetails',
  components: { Card },
  setup() {
    const questionGroupsStore = useQuestionGroupsStore();
    return { questionGroupsStore };
  },
  data() {
    return {
      loading: false,
      savingGroup: false,
      questionsLoading: false,
      questionSaving: false,
      group: null,
      groupForm: { id: null, name: '', description: '', color: '#007bff', is_active: true },
      questions: [],
      sortedQuestions: [],
      editing: false,
      form: this.emptyForm('multiple_choice'),
      singleCorrect: 0
    };
  },
  watch: {
    questions: {
      handler(newQuestions) {
        this.sortedQuestions = [...(newQuestions || [])].map(q => {
          const t = { ...q, answers: [] };
          for (let i = 1; i <= 6; i++) {
            const text = q[`answer_${i}`];
            if (text && String(text).trim() !== '') {
              t.answers.push({
                text: text,
                is_correct: q[`is_answer_${i}_correct`] === true
              });
            }
          }
          return t;
        }).sort((a,b) => {
          if (a.sort_order != null && b.sort_order != null) return a.sort_order - b.sort_order;
          return (a.id||0) - (b.id||0);
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    groupId() {
      return this.$route.params.id;
    }
  },
  async created() {
    await this.loadGroup();
    await this.loadQuestions();
  },
  methods: {
    emptyForm(type = 'multiple_choice') {
      const base = {
        id: null,
        type,
        description: '',
        points: type === 'multiple_choice' ? 10 : 1,
        max_points: type === 'open' ? 1 : null,
        allow_multiple_answers: false,
        sort_order: null,
        image_url: null
      };
      for (let i = 1; i <= 6; i++) {
        base[`answer_${i}`] = '';
        base[`is_answer_${i}_correct`] = false;
      }
      return base;
    },
    async loadGroup() {
      this.loading = true;
      try {
        // Hole alle Gruppen und picke die gesuchte (API liefert keine Single-Route im Anforderungstext)
        await this.questionGroupsStore.fetchQuestionGroups();
        const all = this.questionGroupsStore.getAllQuestionGroups || [];
        const g = all.find(x => String(x.id) === String(this.groupId));
        if (!g) {
          this.$toast.error('Fragengruppe nicht gefunden');
          this.$router.push('/question-groups');
          return;
        }
        this.group = g;
        this.groupForm = {
          id: g.id,
          name: g.name || '',
          description: g.description || '',
          color: g.color || '#007bff',
          is_active: g.is_active !== false
        };
      } finally {
        this.loading = false;
      }
    },
    async loadQuestions() {
      this.questionsLoading = true;
      try {
        const qs = await this.questionGroupsStore.fetchQuestionsByGroup(this.groupId);
        this.questions = Array.isArray(qs) ? qs : [];
      } finally {
        this.questionsLoading = false;
      }
    },
    async onSaveGroup() {
      if (!this.groupForm.name.trim()) {
        this.$toast.error('Bitte Namen eingeben');
        return;
      }
      this.savingGroup = true;
      try {
        await this.questionGroupsStore.updateQuestionGroup(this.groupForm.id, {
          name: this.groupForm.name,
          description: this.groupForm.description,
          color: this.groupForm.color,
          is_active: this.groupForm.is_active
        });
        this.$toast.success('Gruppe gespeichert');
        await this.loadGroup();
      } catch (e) {
        this.$toast.error('Fehler beim Speichern der Gruppe');
      } finally {
        this.savingGroup = false;
      }
    },
    async onDeleteGroup() {
      if (this.group?.questions_count > 0) {
        this.$toast.error('Gruppe kann nicht gelöscht werden (enthält noch Fragen)');
        return;
      }
      if (!confirm('Gruppe wirklich löschen?')) return;
      try {
        await this.questionGroupsStore.deleteQuestionGroup(this.groupId);
        this.$toast.success('Gruppe gelöscht');
        this.$router.push('/question-groups');
      } catch (e) {
        this.$toast.error('Fehler beim Löschen der Gruppe');
      }
    },
    startCreate(type) {
      this.editing = true;
      this.form = this.emptyForm(type);
      this.singleCorrect = 0;
    },
    startEdit(q) {
      this.editing = true;
      // Tiefe Kopie der Frage
      this.form = JSON.parse(JSON.stringify(q));
      // Single correct initialisieren
      if (!this.form.allow_multiple_answers) {
        for (let i = 1; i <= 6; i++) {
          if (this.form[`is_answer_${i}_correct`]) { this.singleCorrect = i; break; }
        }
      } else {
        this.singleCorrect = 0;
      }
    },
    cancelEdit() {
      this.editing = false;
      this.form = this.emptyForm('multiple_choice');
      this.singleCorrect = 0;
    },
    setSingleCorrect(i) {
      for (let x = 1; x <= 6; x++) this.form[`is_answer_${x}_correct`] = false;
      this.form[`is_answer_${i}_correct`] = true;
    },
    validateForm() {
      if (!this.form.description || !this.form.type) return 'Bitte Fragetyp und Beschreibung ausfüllen';
      if (this.form.type === 'multiple_choice') {
        const numAnswers = [1,2,3,4,5,6].filter(i => (this.form[`answer_${i}`] || '').trim() !== '').length;
        const anyCorrect = [1,2,3,4,5,6].some(i => this.form[`is_answer_${i}_correct`] === true);
        if (numAnswers < 2) return 'Mindestens 2 Antworten erforderlich';
        if (!anyCorrect) return 'Mindestens eine Antwort als korrekt markieren';
        if (!this.form.points || this.form.points < 1) return 'Punkte müssen ≥ 1 sein';
      } else if (this.form.type === 'open') {
        if (!this.form.max_points || this.form.max_points < 1) return 'max_points müssen ≥ 1 sein';
      }
      return null;
    },
    async saveQuestion() {
      const error = this.validateForm();
      if (error) { this.$toast.error(error); return; }
      this.questionSaving = true;
      try {
        const payload = this.preparePayload(this.form);
        if (this.form.id) {
          await this.questionGroupsStore.updateGroupQuestion(this.groupId, this.form.id, payload);
        } else {
          await this.questionGroupsStore.createGroupQuestion(this.groupId, payload);
        }
        this.$toast.success('Frage gespeichert');
        await this.loadQuestions();
        this.editing = false;
      } catch (e) {
        this.$toast.error('Fehler beim Speichern der Frage');
      } finally {
        this.questionSaving = false;
      }
    },
    async onDeleteQuestion(q) {
      if (!confirm('Frage wirklich löschen?')) return;
      try {
        await this.questionGroupsStore.deleteGroupQuestion(this.groupId, q.id);
        await this.loadQuestions();
        this.$toast.success('Frage gelöscht');
      } catch (e) {
        this.$toast.error('Fehler beim Löschen der Frage');
      }
    },
    async onImageSelect(e) {
      const file = e.target.files?.[0];
      if (!file) return;
      const formData = new FormData();
      formData.append('image', file);
      try {
        const res = await http.post('/api/upload/question-image', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        this.form.image_url = res.data.url;
      } catch (err) {
        this.$toast.error('Bildupload fehlgeschlagen');
      }
    },
    removeImage() {
      this.form.image_url = null;
    },
    preparePayload(q) {
      const payload = {
        type: q.type,
        description: q.description,
        points: q.type === 'multiple_choice' ? q.points : 1,
        max_points: q.type === 'open' ? q.max_points : undefined,
        allow_multiple_answers: !!q.allow_multiple_answers,
        sort_order: q.sort_order || undefined,
        image_url: q.image_url || undefined
      };
      for (let i = 1; i <= 6; i++) {
        if (q[`answer_${i}`]) payload[`answer_${i}`] = q[`answer_${i}`];
        if (q[`is_answer_${i}_correct`] !== undefined) payload[`is_answer_${i}_correct`] = !!q[`is_answer_${i}_correct`];
      }
      return payload;
    }
  }
};
</script>

<style lang="scss" scoped>
.qg-details { min-height: 100vh; }

.card-modern {
  border-radius: 16px;
  border: 1px solid rgba(0,0,0,0.06);
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
}

:deep(.btn.btn-with-icon) { gap: .35rem; }
:deep(.btn) { border-radius: 10px; }
:deep(.btn.btn-primary), :deep(.btn.btn-info) { box-shadow: 0 4px 12px rgba(0,113,227,.16); }

:deep(.form-control.apple-style),
:deep(.form-select.apple-style) {
  background: var(--gray-100, #f5f5f7);
  border-color: transparent;
  transition: all .2s ease;
  border-radius: 12px;
  padding: 0.625rem 0.9rem;
}

:deep(.form-control.apple-style:focus),
:deep(.form-select.apple-style:focus) {
  background: #fff;
  border-color: var(--input-border-color);
  box-shadow: 0 0 0 3px rgba(0,113,227,.15);
}

.editor {
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 14px;
  background: var(--card-bg);
}

/* Antworten Input-Gruppen kompakter + korrekte Antwort grün unterlegt */
:deep(.input-group) { border-radius: 12px; overflow: hidden; }
:deep(.input-group-text) { background: var(--gray-100, #f5f5f7); border: 1px solid var(--bs-border-color); }
:deep(.input-group.is-correct .form-control) { background: rgba(var(--bs-success-rgb), .05); border-color: rgba(var(--bs-success-rgb), .35); }

/* Fragenliste modern wie im Test-Editor */
.questions-list-modern {
  margin-top: 1.5rem;
}
.questions-list-modern .question-card {
  background-color: var(--card-bg);
  border-radius: 0.75rem;
  padding: 1.25rem 1.25rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid var(--bs-border-color-translucent);
  box-shadow: 0 6px 18px rgba(0,0,0,.06);
  position: relative;
  color: var(--text-color);
  border-left: 4px solid transparent;
}
.questions-list-modern .question-card.question-card-primary { border-left-color: var(--bs-primary); }
.questions-list-modern .question-card.question-card-info { border-left-color: var(--bs-info); }

.questions-list-modern .question-header {
  border-bottom: 1px solid var(--bs-border-color-translucent);
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.questions-list-modern .question-number-badge {
  font-size: 0.8rem; font-weight: 600;
  background-color: var(--bs-gray-200); color: var(--bs-gray-700);
  min-width: 24px; height: 24px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center;
}
.questions-list-modern .question-type-badge { font-size: 0.8rem; padding: 0.3rem 0.6rem; }

/* Moderne Action-Icons rechts */
.questions-list-modern .question-actions { margin-left: auto; display: flex; gap: 0.35rem; }
.questions-list-modern .btn-action {
  background: #fff; border: 1px solid var(--bs-border-color); color: var(--bs-gray-700);
  padding: 0.35rem; border-radius: 10px; width: 34px; height: 34px; display: inline-flex; align-items: center; justify-content: center;
  transition: background-color .2s ease, box-shadow .2s ease, color .2s ease, transform .1s ease;
}
.questions-list-modern .btn-action:hover { background: var(--bs-light); box-shadow: 0 6px 16px rgba(0,0,0,.08); transform: translateY(-1px); }
.questions-list-modern .btn-action-edit:hover { color: var(--bs-primary); }
.questions-list-modern .btn-action-delete:hover { color: var(--bs-danger); background: rgba(var(--bs-danger-rgb), 0.08); }

/* Antwortenanzeige */
.answers-title { margin-bottom: 0.5rem !important; }
.answers-container .answer-item { background-color: var(--bs-gray-100); border: 1px solid var(--bs-border-color); padding: 0.6rem 0.9rem; border-radius: 8px; margin-bottom: 0.5rem; position: relative; }
.answers-container .answer-item .answer-content { display: flex; align-items: center; gap: 0.6rem; }
.answers-container .answer-item .answer-status-icon { font-size: 1.05rem; color: var(--bs-gray-500); }
.answers-container .answer-item.answer-item-correct { background-color: rgba(var(--bs-success-rgb), 0.1); border-color: rgba(var(--bs-success-rgb), 0.35); border-left: 4px solid var(--bs-success); }
.answers-container .answer-item.answer-item-correct .answer-status-icon { color: var(--bs-success); }
</style> 